
import { Fragment, useEffect, useMemo, useState, useCallback, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import rg4js from 'raygun4js';

import { useJobsAdminToolsMutation } from "../../services/jobsAdminToolsApi";
import { useJobsAdminToolsAuxMutation } from "../../services/jobsAdminToolsAuxApi";
import { useJobStatusQuery, useJobPriorityQuery } from "../../services/jobsLookUpTables";
import { useAccountsCacheQuery } from "../../services/accountsApi";
import { useGetEventsMutation } from "../../services/eventApi";
import { useGetEventsAuxMutation } from "../../services/eventAuxApi";
//A rtk querys to get data from EH API.

import { DataGridPro, GridToolbar, getGridNumericOperators, getGridSingleSelectOperators } from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Counter from './../../components/Counter';
import JobDescription from "../../components/jobDescription";
//A: components

import { parseToEasternTime, eventDatesFormatter } from './../../utils/dates';
import { openStnInvoice } from "../../utils";
//A: helper functions

import searchIcon from "../../img/search-icon.svg";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../features/auth/authSlice";
import SignalREncorehiveContext from "../../context/signalREncorehive";
//A: assets

function arrayToDictionary(array, key = 'id') {
  return Object.assign({}, ...array.map((x) => ({ [x[key]]: x })))
}

function getEscalationActive(escalations) {
  return escalations.find(escalation => !escalation.issueResolved);
}
function GetCreatedDate(params) {
  return params.row.createdOn ? parseToEasternTime(params.row.createdOn) : "-";
}

function getmodifiedOn(params) {
  if (!params.row.modifiedOn && params.row.createdOn) {
    return parseToEasternTime(params.row.createdOn);
  } else {
    return parseToEasternTime(params.row.modifiedOn);
  }
}

function PriorityButton({ priority }) {
  return (
    <button
      style={{ cursor: "auto" }}
      className={`button button-${priority === "Urgent"
        ? "inactive"
        : priority === "Default"
          ? "active"
          : priority === "pending"
            ? "pending"
            : "unverified"
        }`}
    >
      {priority}
    </button>
  );
}

function getCurrentOwner(params, accounts) {
  let currentOwnerId = params.row.currentOwnerHiveUserId;
  if (!accounts) return "Loading";
  return currentOwnerId
    ? accounts[currentOwnerId]?.firstName + " " + accounts[currentOwnerId]?.lastName
    : "";
}

function getNameOfCurrentAdminInCharge(params, accounts) {
  let activeEscalation = getEscalationActive(params.row.escalations);
  if (!activeEscalation) return "-"; //A: no active escalation

  if (activeEscalation.issueResolvedSTNUserID == null) return "-"; //A: no admin in charge

  if (!accounts) return "Loading";

  let adminInCharge = accounts[activeEscalation.issueResolvedSTNUserID];
  return `${adminInCharge.firstName} ${adminInCharge.lastName}`;
}

function getEventName(row, events) {
  if (!row.eventId) return "-";
  if (!events) return "Loading";
  return events[row.eventId]?.name;
}

function getEventDates(row, events) {
  if (!row.eventId) return "-";
  if (!events) return "Loading";
  return eventDatesFormatter(events[row.eventId]?.date);
}

function getEventVenue(row, events) {
  if (!row.eventId) return "-";
  if (!events) return "Loading";
  return events[row.eventId]?.venue.name;
}

function createHeaders(history, setShowPreview, jobsLookUpTables, userLookUpTable, eventsLookUpTable) {
  return [
    {
      headerName: "",
      filterable: false,
      field: "edit",
      flex: 0,
      align: "center",
      renderCell: (params) => {
        return (
          <button
            className="edit-button"
            onClick={() => {
              if (!eventsLookUpTable) return;
              let event = eventsLookUpTable[params.row.eventId];
              setShowPreview({ ...params.row, ...event })
            }}
          >
            <img src={searchIcon} alt="search icon" height="18px" width="18px" />
          </button>
        );
      },
    },
    {
      headerName: "ID",
      field: "id",
      filterOperators: getGridNumericOperators().filter(
        (operator) => operator.value !== 'isAnyOf', //A: remove isAnyOf operator
      ),
      type: 'number',
      valueGetter: (params) => parseInt(params.row.id),
      flex: 1,
      renderCell: (params) => {
        return (
          <p
            style={{
              cursor: "pointer",
              color: "DodgerBlue",
              textDecoration: "underline",
            }}
            onClick={() =>
              history.push("/dashboard/admintools/jobs/" + params.row.id)
            }
          >
            {params.row.id}
          </p>
        );
      },
    },
    {
      headerName: "JOB STATUS",
      field: "status.Name", //WARNING: if change this name the sort will not work
      filter: "agMultiColumnFilter",
      filterOperators: getGridSingleSelectOperators().filter(
        (operator) => operator.value !== 'isAnyOf', //A: remove isAnyOf operator
      ),
      type: 'singleSelect',
      valueOptions: jobsLookUpTables?.jobStatus && Object.values(jobsLookUpTables?.jobStatus).map(status => ({ value: status.id, label: status.name })),
      valueGetter: (params) => jobsLookUpTables?.jobStatus[params.row.statusId].name,
      flex: 1,
      align: "center",
    },
    {
      headerName: "JOB PRIORITY",
      field: "priority.Name", //WARNING: if change this name the sort will not work
      filterOperators: getGridSingleSelectOperators().filter(
        (operator) => operator.value !== 'isAnyOf', //A: remove isAnyOf operator
      ),
      type: 'singleSelect',
      valueOptions: jobsLookUpTables?.jobPriority && Object.values(jobsLookUpTables?.jobPriority).map(status => ({ value: status.id, label: status.name })),
      renderCell: (params) => {
        let priority = jobsLookUpTables?.jobPriority[params.row.priorityId].name;
        return <PriorityButton priority={priority} />;
      },
      flex: 1,
      align: "center",
    },
    {
      headerName: "JOB TYPE",
      field: "type.Name", //WARNING: if change this name the sort will not work
      valueGetter: (params) => "Hive Buy",
      valueOptions: [{ value: "Hive Buy", label: "Hive Buy" }],
      filterable: false,
      sortable: false,
      flex: 1
    },
    { headerName: "EVENT NAME", sortable: false, filterable: false, field: "name", valueGetter: (params) => getEventName(params.row, eventsLookUpTable), flex: 1 },
    { headerName: "EVENT DATE", sortable: false, filterable: false, field: "date", valueGetter: (params) => getEventDates(params.row, eventsLookUpTable), flex: 1 },
    { headerName: "EVENT VENUE", sortable: false, filterable: false, field: "eventVenue", valueGetter: (params) => getEventVenue(params.row, eventsLookUpTable), flex: 1, },
    { headerName: "CREATED TIMESTAMP", field: "createdOn", valueGetter: GetCreatedDate, flex: 1 },
    {
      headerName: "INVOICE ID",
      field: "invoiceID",
      type: 'number',
      filterOperators: getGridNumericOperators().filter(
        (operator) => operator.value !== 'isAnyOf', //A: remove isAnyOf operator
      ),
      valueGetter: (params) => parseInt(params.row.invoiceID),
      flex: 1,
      renderCell: (params) => {
        return (
          <p
            style={{
              cursor: "pointer",
              color: "DodgerBlue",
              textDecoration: "underline",
            }}
            onClick={() => openStnInvoice(params.row.invoiceID)}
          >
            {params.row.invoiceID}
          </p>
        );
      },
    },
    {
      headerName: "CURRENT OWNER",
      filterable: false,
      field: "currentOwner",
      valueGetter: (params) => getCurrentOwner(params, userLookUpTable),
      flex: 1,
    },
    {
      headerName: "ADMIN IN PROCESS",
      sortable: false,
      filterable: false,
      field: "escalationActive",
      valueGetter: (params) => getNameOfCurrentAdminInCharge(params, userLookUpTable),
      flex: 1,
    },
    {
      headerName: "LAST UPDATE",
      filterable: false,
      field: "modifiedOn",
      valueGetter: (params) => params.row.modifiedOn ? new Date(params.row.modifiedOn).valueOf() : new Date(params.row.createdOn).valueOf(),
      flex: 1,
      renderCell: (params) => {
        // BEE-746
        if (!jobsLookUpTables || jobsLookUpTables.jobStatus.length === 0) return "Loading";
        let statusName = jobsLookUpTables.jobStatus[params.row.statusId]?.name;
        let showMinutes = ((statusName !== "Completed") && (statusName !== "Canceled") && (params.row.modifiedOn || params.row.createdOn))
        if (showMinutes) return <Counter timestamp={params.row.modifiedOn || params.row.createdOn} />
        return getmodifiedOn(params)
      }
    },
    {
      headerName: "ESCALATED?",
      field: "escalated",
      sortable: false, filterable: false,
      flex: 0,
      align: "center",
      // valueGetter: getEscalated,
      renderCell: (params) => {
        if (!jobsLookUpTables || jobsLookUpTables.jobStatus.length === 0) return "Loading";
        let statusName = jobsLookUpTables.jobStatus[params.row.statusId]?.name;
        let escalationActive = getEscalationActive(params.row.escalations);
        let escalationInProgress = false;
        if (escalationActive && escalationActive.issueTaken != null) escalationInProgress = true;

        if (statusName !== "Escalated") return "";

        return (
          <Box
            sx={{
              backgroundColor: escalationInProgress
                ? "var(--orange)"
                : "var(--red)",
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <InfoOutlinedIcon
              sx={{
                cursor: "pointer",
                color: "white",

                textDecoration: "underline",
              }}
              onClick={() =>
                history.push(
                  "/dashboard/admintools/jobs/" +
                  params.row.id +
                  "?tab_index=2"
                )
              }
            />
          </Box>
        );

      },
    },
  ];
}

export default function ManageJobsRefactor(props) {
  /*
    documentation of session store:
    we save three things in session store:
    1.DATAGRID_FILTERS_MUI: the filters with the object structure that dagrid expects
    2.DATAGRID_FILTERS_SERVER_V2: the filters that are applied to the server(only filters and the operator)
    3.DATAGRID_FULL_QUERY_OPTIONS: we use this to refetch with full query options when a signalR notification comes in. (same filters, page, pageSize, sort)
    in the future we can mix 2 and 3 
  */
  let history = useHistory();
  const { signalREncorehive: signalRConnection } = useContext(SignalREncorehiveContext);
  
  const user= useSelector(selectCurrentUser);
  let connection = signalRConnection;

  const [showPreview, setShowPreview] = useState(false);
  const [pageNumber, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [orderColumn, setOrderColum] = useState({ columnName: "id", direction: "desc" }); //A: if you delete this default value go and update the initial state of the datagrid component lookfor this line: "initialState={{"
  //A: for server, default sort if you change this change also the defaultSortModelMUI
  const defaultServerSortModel = {
    "filters": [
      {
        "name": "statusId",
        "operator": "IsEqualTo",
        "value": 1
      },
      {
        "name": "statusId",
        "operator": "IsEqualTo",
        "value": 4
      },
      {
        "name": "statusId",
        "operator": "IsEqualTo",
        "value": 2
      },
      {
        "name": "statusId",
        "operator": "IsEqualTo",
        "value": 3
      }
    ],
    "operator": "or"
  }
  let userFiltersSavedServer = window.sessionStorage.getItem("DATAGRID_FILTERS_SERVER_V2");
  let initialServerSortModel = userFiltersSavedServer ? JSON.parse(userFiltersSavedServer) : defaultServerSortModel;
  const [filterColumns, setFilterColumns] = useState(initialServerSortModel);

  //A: for material UI datagrid
  const defaultSortModelMUI = {
    "items": [
      {
        "columnField": "status.Name",
        "operatorValue": "is",
        "id": 35914,
        "value": 1
      },
      {
        "columnField": "status.Name",
        "operatorValue": "is",
        "id": 27842,
        "value": 4
      },
      {
        "columnField": "status.Name",
        "operatorValue": "is",
        "id": 33127,
        "value": 2
      },
      {
        "columnField": "status.Name",
        "operatorValue": "is",
        "id": 89086,
        "value": 3
      }
    ],
    "linkOperator": "or",
    "quickFilterValues": [],
    "quickFilterLogicOperator": "and"
  }
  let userFiltersSavedMUI = window.sessionStorage.getItem("DATAGRID_FILTERS_MUI");
  let initialSortModelMUI = userFiltersSavedMUI ? JSON.parse(userFiltersSavedMUI) : defaultSortModelMUI;


  const [getJobs, { data: jobsRes, isLoading: isJobsLoading, error: jobsError, isSuccess: isJobsSuccess, isError: isJobsError }] = useJobsAdminToolsMutation();
  const [getJobsAux] = useJobsAdminToolsAuxMutation();
  const [jobs, setJobs] = useState([]);

  // references for the current user and the current query options 
  const userRef = useRef({});
  userRef.current = user;
  const queryOptionsRef = useRef({
    pageSize,
    pageNumber,
    orderColumn,
    filterColumns: filterColumns?.filters,
    operator: filterColumns?.operator
  });

  useEffect(() => {
    queryOptionsRef.current = {
      pageSize,
      pageNumber,
      orderColumn,
      filterColumns: filterColumns?.filters,
      operator: filterColumns?.operator
    };
  }, [pageNumber, pageSize, orderColumn, filterColumns]);

  useEffect(() => {
    getJobs(queryOptionsRef.current);
  }, [queryOptionsRef.current]);

  useEffect(() => {
    if (isJobsSuccess) {
      setJobs(jobsRes);
    }
  }, [isJobsSuccess]);

  //A: GET AND SET THE LOOKUP TABLES
  const { data: jobStatus, isSuccess: isJobStatusSuccess, isJobStatusLoading, isJobStatusError, JobStatusError } = useJobStatusQuery();
  const { data: jobPriority, isSuccess: isJobPrioritySuccess, isJobPriorityLoading, isJobPriorityError, JobPriorityError } = useJobPriorityQuery();
  const lookUpTablesLoading = isJobStatusLoading || isJobPriorityLoading;
  const lookUpTable = useMemo(() => {
    if (lookUpTablesLoading) {
      return { jobStatus: {}, jobPriority: {}, jobType: {} };
    }
    if (isJobStatusSuccess && isJobPrioritySuccess) {
      return {
        jobStatus: arrayToDictionary(jobStatus),
        jobPriority: arrayToDictionary(jobPriority),
      }
    }
  }, [isJobStatusSuccess, isJobPrioritySuccess]);

  const { data: usersRes, isSuccess: isUsersSuccess, IsError: usUsersError } = useAccountsCacheQuery();
  const userLookUpTable = useMemo(() => {
    if (isUsersSuccess) {
      return arrayToDictionary(usersRes.res.accounts);
    }
  }, [isUsersSuccess]);


  const [getEventsAux] = useGetEventsAuxMutation();
  const [eventsLookUpTable, setEventsLookUpTable] = useState({});

  const columns = useMemo(() => {
    return createHeaders(history, setShowPreview, lookUpTable, userLookUpTable, eventsLookUpTable);
  }, [history, setShowPreview, lookUpTable, userLookUpTable, eventsLookUpTable])

  //END: GET AND SET THE LOOKUP TABLES

  //A: DATAGRID EVENTS HANDLER AND STATE

  const handleSortModelChange = useCallback((sortModel) => {
    try {
      function getColumnName(columnName) {
        let columnNameParsed = "";
        switch (columnName) {
          case "status":
            columnNameParsed = "status.Name";
            break;
          default:
            columnNameParsed = columnName;
        }
        return columnNameParsed;
      }
      console.log(sortModel);
      let orderColumn = {}
      if (sortModel && sortModel.length > 0) orderColumn = { columnName: getColumnName(sortModel[0].field), direction: sortModel[0].sort };
      console.log("setting orderColumn: ", orderColumn);
      setOrderColum(orderColumn);
    } catch (error) {
      console.log("AdminTools: handleSortModelChange, user: " + JSON.stringify(userRef.current));
      console.log("AdminTools: handleSortModelChange, sortModel: " + JSON.stringify(sortModel));
      console.log("AdminTools: handleSortModelChange error: ", JSON.stringify(error));
      console.log("AdminTools: handleSortModelChange error message: ", error.message);
      console.log("AdminTools: handleSortModelChange error stack: ", error.stack);
      console.log("AdminTools: handleSortModelChange error stack: ", JSON.stringify(error.stack));
      if (error instanceof Error) {
        if (!error.message) error.message = "AdminTools: handleSortModelChange error: " + error.message;
        rg4js('send', {
          error: error,
          tags: ['handled_exception']
        });
      }
      else {
        let errorCreated = new Error("AdminTools: handleSortModelChange error: " + error.message);
        rg4js('send', {
          error: errorCreated,
          tags: ['handled_no_error_instance']
        })
      }
      throw new Error("AdminTools: handleSortModelChange error: " + error.message);
    }
  }, []);

  const onFilterChange = useCallback((filterModel) => {
    try {
      console.log(filterModel);
      window.sessionStorage.setItem(
        "DATAGRID_FILTERS_MUI",
        JSON.stringify(filterModel)
      );
      //When user close the Browser tab the default filters will be aplied. this is not affected by a windows refresh

      let items = filterModel.items;

      if (items.length <= 0) {
        let filterModelServer = { filters: [], operator: "or" };
        setFilterColumns(filterModelServer);
        window.sessionStorage.setItem(
          "DATAGRID_FILTERS_SERVER_V2",
          JSON.stringify(filterModelServer)
        );
        //When user close the Browser tab the default filters will be aplied. this is not affected by a windows refresh
      }
      function getColumName(columnField) {
        switch (columnField) {
          case "status.Name":
            return "statusId";
          case "priority.Name":
            return "priorityId";
          case "type.Name":
            return "typeId";
          default:
            return columnField;
        }
      }

      function getColumnOperator(operatorValue) {
        switch (operatorValue) {
          case "is":
            return "IsEqualTo";
          case "not":
            return "IsNotEqualTo";
          case "equals":
            return "IsEqualTo";
          case "=":
            return "IsEqualTo";
          case "!=":
            return "Distinct";
          case ">":
            return "GreaterThan";
          case ">=":
            return "GreaterThanOrEqualTo";
          case "<":
            return "LessThan";
          case "<=":
            return "LessThanOrEqualTo";
          case "isEmpty":
            return "isNull";
          case "isNotEmpty":
            return "isNotNull";
          default:
            return operatorValue;
        }
      }

      let filters = items.map(item => {
        let columFieldExists = item.columnField && item.columnField !== "";
        let operatorValueExists = item.operatorValue && item.operatorValue !== "";
        let valueExists = item.value && item.value !== "";
        let operatorNotNeedValue = item.operatorValue === "isNotEmpty" || item.operatorValue === "isEmpty"; //A: operators that don't need a value
        if (operatorNotNeedValue || (columFieldExists && operatorValueExists && valueExists)) {
          return {
            name: getColumName(item.columnField),
            operator: getColumnOperator(item.operatorValue),
            value: item.value
          }
        }
      })
      filters = filters.filter(filter => filter !== undefined && filter !== null);

      if (filters.length <= 0) return;
      let filterModelServer = { filters, operator: filterModel.linkOperator };
      window.sessionStorage.setItem(
        "DATAGRID_FILTERS_SERVER_V2",
        JSON.stringify(filterModelServer)
      );
      setFilterColumns(filterModelServer);
    } catch (error) {
      console.log("AdminTools: onFilterChange, user: " + JSON.stringify(userRef.current));
      console.log("AdminTools: onFilterChange, filterModel: " + JSON.stringify(filterModel));
      console.log("AdminTools: onFilterChange error: ", JSON.stringify(error));
      console.log("AdminTools: onFilterChange error message: ", error.message);
      console.log("AdminTools: onFilterChange error stack: ", error.stack);
      console.log("AdminTools: onFilterChange error stack: ", JSON.stringify(error.stack));
      if (error instanceof Error) {
        if (!error.message) error.message = "AdminTools: onFilterChange error: " + error.message;
        rg4js('send', {
          error: error,
          tags: ['handled_exception']
        });
      }
      else {
        console.error("TESTING ERROR")
        let errorCreated = new Error("AdminTools: onFilterChange error: " + error.message);
        rg4js('send', {
          error: errorCreated,
          tags: ['handled_no_error_instance']
        })
      }
      throw new Error("AdminTools: onFilterChange error: " + error.message);
    }
  }, []);

  async function refetchAux(jobId) {

    try {
      console.log("refetchAux, queryOptionsAux: ", JSON.stringify(queryOptionsRef.current));

      let res
      try {
        res = await getJobsAux(queryOptionsRef.current).unwrap();
      }
      catch (error) {
        console.log("getAvailableJobs_2 error: " + JSON.stringify(error))
        if (error.status == 401) return; //error managed on baseQueryWithReauth 
        throw error
      }
      console.log("refetchAux: ", JSON.stringify(res));
      setJobs(res);
    } catch (error) {
      console.log("AdminTools, refetchAux, job: ", JSON.stringify(jobId));
      console.log("AdminTools: refetchAux, user: " + JSON.stringify(userRef.current));
      console.log("AdminTools: refetchAux, current query options: " + JSON.stringify(queryOptionsRef.current));
      console.log("AdminTools, refetchAux, error: ", JSON.stringify(error));
      console.log("AdminTools, refetchAux, error message: ", error.message);
      console.log("AdminTools, refetchAux, error stack: ", error.stack);
      console.log("AdminTools, refetchAux, error stack: ", JSON.stringify(error.stack));

      if (error.data?.message == "Unauthorized") {
        // this error is already handled by the getJobsAux and the user is already logged out
        console.log("AdminTools, refetchAux, ignoring error: ", JSON.stringify(error));
        return;
      }

      if (error instanceof Error) {
        if (!error.message) error.message = "AdminTools, refetchAux, error: " + error.message;
        rg4js('send', {
          error: error,
          tags: ['handled_exception']
        });
      }
      else {
        console.log("SENDING CUSTOM ERROR TO RAYGUN")
        let errorCreated = new Error("AdminTools, refetchAux, error: " + error.message);
        rg4js('send', {
          error: errorCreated,
          tags: ['handled_no_error_instance']
        })
      }
      throw new Error("throw on refetchAux, message: " + error.message);
    }
  }

  useEffect(async () => {
    try {
      let eventsIdsToFetch = [];
      (jobs?.jobs || []).forEach(job => {
        if (!eventsLookUpTable[job.eventId]) {
          eventsIdsToFetch.push(job.eventId);
        }
      });
      console.log("effect, eventsIdsToFetch: ", JSON.stringify(eventsIdsToFetch));
      if (eventsIdsToFetch.length > 0) {
        let res
        try {
          res = await getEventsAux(eventsIdsToFetch).unwrap();
        }
        catch (error) {
          console.log("getAvailableJobs_2 error: " + JSON.stringify(error))
          if (error.status == 401) return; //error managed on baseQueryWithReauth 
          throw error
        }
        let events = res.map((event) => event.eventModel);
        let eventsAsDict = arrayToDictionary(events, "bteId");
        setEventsLookUpTable({ ...eventsLookUpTable, ...eventsAsDict });
      }

    } catch (error) {
      console.log("AdminTools: useEffect events, user: " + JSON.stringify(userRef.current));
      console.log("AdminTools: useEffect events error: ", JSON.stringify(error));
      console.log("AdminTools: useEffect events error message: ", error.message);
      console.log("AdminTools: useEffect events error stack: ", error.stack);
      console.log("AdminTools: useEffect events error stack: ", JSON.stringify(error.stack));
      if (error instanceof Error) {
        if (!error.message) error.message = "AdminTools: useEffect events error: " + error.message;
        rg4js('send', {
          error: error,
          tags: ['handled_promise_rejection']
        });
      }
      else {
        let errorCreated = new Error("AdminTools: useEffect events error: " + error.message);
        rg4js('send', {
          error: errorCreated,
          tags: ['handled_no_error_instance']
        })
      }
    }
  }, [jobs, eventsLookUpTable]);

  //A: signalR
  useEffect(() => {
    if (connection) {

      connection.on("HardEscalate", (jobId) => {
        console.log("SignalR, HardEscalate on manage jobs refactor jobId: ", jobId);
        refetchAux(jobId);
      });

      connection.on("JobEscalationResolved", (jobId) => {
        console.log("SignalR, JobEscalationResolvedon manage jobs refactor jobId: ", jobId);
        refetchAux(jobId);
      });

      connection.on("JobClaimed", (jobId) => {
        console.log("SignalR, JobClaimed jobId:", jobId);
        refetchAux(jobId);
      });

      connection.on("JobEscalated", (jobId) => {
        console.log("SignalR, JobEscalated jobId:", jobId);
        refetchAux(jobId);
      });

      connection.on("IssueTaked", (jobId) => {
        console.log("SignalR, IssueTaked jobId:", jobId);
        refetchAux(jobId);
      });

      connection.on("NewJobPurchase", (jobId) => {
        console.log("SignalR, NewJobPurchase': ", jobId);
        refetchAux(jobId);
      });

      connection.on("NewJob", (res) => {
        console.log("SignalR, NewJob jobId:", res);
        refetchAux(res);
      });

      connection.on("JobEdited", (res) => {
        console.log("SignalR, JobEdited': ", res);
        refetchAux(res);
      });
    }
  }, [connection]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };

  if (isJobsError) {
    console.log("AdminTools: isJobsError: ", JSON.stringify(jobsError));
    console.log("AdminTools: isJobsError queryOptions: ", JSON.stringify(queryOptionsRef.current));
    rg4js('send', {
      error: jobsError,
      tags: ['handled_promise_rejection']
    });
  }

  return (
    <Fragment>
      <div className="tab-title-container">
        <h3 style={{ margin: "0 1em 0 0" }}>Manage Jobs</h3>
      </div>

      {isJobsError && <p>Error Fetching Data {JSON.stringify(jobsError)}</p>}

      {showPreview && (
        <Modal
          open={showPreview}
          onClose={() => setShowPreview(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <JobDescription currentJob={showPreview}></JobDescription>
          </Box>
        </Modal>
      )}
      {/* A: quick job preview */}
      {(!isJobsError) && (
        <div style={{ height: "75vh", width: "100%" }}>
          <DataGridPro
            paginationMode="server"
            initialState={{
              sorting: {
                sortModel: [{ field: 'id', sort: 'asc' }],
              },
              filter: {
                filterModel: { ...initialSortModelMUI }
              },

            }}
            rowCount={jobs?.count || 0}
            onPageChange={setPage}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            page={pageNumber}
            pageSize={pageSize}
            sx={{
              borderRadius: "1em",
              backgroundColor: "white",
              padding: "1em",
            }}
            loading={isJobsLoading || lookUpTablesLoading}
            rows={jobs?.jobs || []}
            columns={columns || []}
            // onFilterModelChange={handleFilterChange}
            disableSelectionOnClick
            components={{
              Toolbar: GridToolbar,
            }}
            pagination

            sortingMode="server"

            onSortModelChange={handleSortModelChange}
            onFilterModelChange={onFilterChange}

            filterMode="server"
          />
        </div>
      )}
      {/* A: datagrid with job list */}
    </Fragment>
  );
}